import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import "animate.css/animate.min.css";




ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
